import { ZStackChild, ZStackRoot } from "./parts";

const ZStack = Object.assign(ZStackRoot, {
  Child: ZStackChild,
});

export default ZStack;
